var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.5,
    width: 31,
    height: 21,
    rx: 2.5,
    ry: 2.5,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 1H3a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h26a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3Zm2 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2Z",
    fill: "#d8d8d8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.1 8.1-2 5.3-.2-1.1a5.87 5.87 0 0 0-2.8-3.2l1.8 6.8H9l3.2-7.7Zm13.8 5c.2-.4.8-2.2.8-2.2a6.66 6.66 0 0 0 .3-.7l.1.7s.4 1.8.5 2.2Zm2.5-5h-1.6a1 1 0 0 0-1.1.6l-3 7.1h2.1s.3-1 .4-1.2h2.6a9.64 9.64 0 0 1 .2 1.2h2Zm-5.2.2a5.66 5.66 0 0 0-1.8-.3c-2 0-3.4 1-3.4 2.6a2.45 2.45 0 0 0 1.8 2.1c.8.4 1.1.6 1 1a1.1 1.1 0 0 1-1.2.8 4.06 4.06 0 0 1-1.9-.4l-.3-.1-.3 1.7a5.87 5.87 0 0 0 2.3.4c2.1 0 3.5-1 3.5-2.6 0-.9-.5-1.6-1.7-2.1-.7-.4-1.1-.6-1.1-1s.4-.7 1.2-.7a4 4 0 0 1 1.5.3h.1Zm-9.4 7.6 1.3-7.7h2l-1.3 7.7Z",
    fill: "#00579d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 8.1H3v.2a6.67 6.67 0 0 1 4.9 4l-.7-3.5a1 1 0 0 0-.9-.7",
    fill: "#f9a732"
  })));
};
export default SvgVisa;